import React from 'react';

const PasosExplicacion = ({ precio, categoriaCredencial }) => {
    return (
        <div className="pasos-explicacion">
            <p className="planes-titulo --roboto">¿Qué pasa a continuación?</p>
            <ul className="--roboto">
                <li>Empezás a disfrutar del nuevo plan desde hoy</li>
                <li>A partir del próximo débito se te cobrará ${precio}/mes.</li>
                <li>Las credenciales de Club LA NACION son distribuidas en domicilios de Argentina</li>
                {categoriaCredencial == 3 && (
                    <li>Se te enviarán las nuevas credenciales Club LA NACION Black. Hasta tanto, las credenciales premium siguen siendo válidas</li>
                )}
            </ul>
        </div>
    );
};

export default PasosExplicacion;
